import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import * as Tooltip from '@radix-ui/react-tooltip';
import { AppErrorBoundary } from '@/components/AppErrorBoundary';
import { ThemeProvider } from '@/theme/theme';
import { SettingsProvider } from '@/settings/settings';
import { RoleProvider } from '@/auth/role';
import { IncidentProvider } from '@/incident/store';
import { App } from '@/App';
import './styles/index.css';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <AppErrorBoundary>
      <ThemeProvider>
        <SettingsProvider>
        <RoleProvider>
          <IncidentProvider>
            <Tooltip.Provider delayDuration={200}>
              <App />
            </Tooltip.Provider>
          </IncidentProvider>
        </RoleProvider>
        </SettingsProvider>
      </ThemeProvider>
    </AppErrorBoundary>
  </StrictMode>,
);
